export const normalizedDate = (date) => date.toLocaleDateString().split("/").join(".");
